import { useFieldArray, useForm } from "react-hook-form";
import { CategoryModal } from "../CategoryGrid";
import * as React from "react";
import { generatedWaste, renderOptions, sortAlphabetically } from "../Category/helpers";
import { FormSelect, NumericFormInput } from "../../../../../../components/Forms";
import { useTranslation } from "react-i18next";
import { VALIDATION_PATTERNS } from "../../../../../../utils";

function WasteGeneratedInOperationsModalWrapper({
                                                  tabKey,
                                                  modalData,
                                                  attributesOrder,
                                                  isOpen,
                                                  onClose,
                                                  onSubmit,
                                                  getEmptyRow
                                                }) {
  const { fieldArrayName, editData } = modalData;
  const { t } = useTranslation("translation", {
    keyPrefix: "organizationQuestionnaire.scope3"
  });
  const { t: globalTranslation } = useTranslation("translation");

  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    watch,
    resetField
  } = useForm({
    defaultValues: {
      [fieldArrayName]: [editData ? editData : getEmptyRow()]
    }
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: fieldArrayName
  });

  const watchFieldArray = watch(fieldArrayName);

  const renderWasteActivityOptions = () => {
    const optionsArr = generatedWaste.map(el => el.activity).sort(sortAlphabetically);
    const translationKey = "organizationQuestionnaire.scope3.inputs.wasteGeneratedInOperations.wasteActivity.options";

    return renderOptions(optionsArr, translationKey);
  };

  const renderWasteTypeOptions = (selectedWasteActivity) => {
    const foundObj = generatedWaste.find(el => el.activity === selectedWasteActivity);
    const optionsArr = foundObj && foundObj.types ? Object.keys(foundObj.types).sort(sortAlphabetically) : [];
    const translationKey = `organizationQuestionnaire.scope3.inputs.wasteGeneratedInOperations.wasteType.options.${selectedWasteActivity}`;

    return renderOptions(optionsArr, translationKey);
  };

  const renderDisposalMethodOptions = (selectedActivity, selectedType) => {
    const foundObj = generatedWaste.find(el => el.activity === selectedActivity);
    const optionsArr = foundObj && foundObj.types && foundObj.types[selectedType] ?
      foundObj.types[selectedType].sort(sortAlphabetically) : [];
    const translationKey = "organizationQuestionnaire.scope3.inputs.wasteGeneratedInOperations.disposalMethod.options";

    return renderOptions(optionsArr, translationKey);
  };

  const mapRow = (row, index) => {
    const gridItems = [];
    const wasteActivitySelector = register(`${fieldArrayName}.${index}.wasteActivity`, {
      required: globalTranslation("entityRequired", { entityName: t(`inputs.${tabKey}.wasteActivity.name`) })
    });
    const wasteTypeSelector = register(`${fieldArrayName}.${index}.wasteType`, {
      required: globalTranslation("entityRequired", { entityName: t(`inputs.${tabKey}.wasteType.name`) })
    });

    gridItems.push(
      <FormSelect
        errors={errors}
        {...wasteActivitySelector}
        onChange={(e) => {
          wasteActivitySelector.onChange(e);
          resetField(`${fieldArrayName}.${index}.wasteType`, { defaultValue: "" });
          resetField(`${fieldArrayName}.${index}.disposalMethod`, { defaultValue: "" });
        }}
        placeholder=" "
        title={watchFieldArray[index].wasteActivity !== "" ?
          t(`inputs.wasteGeneratedInOperations.wasteActivity.options.${watchFieldArray[index].wasteActivity}`) : ""}
      >
        {renderWasteActivityOptions()}
      </FormSelect>
    );
    gridItems.push(
      <FormSelect
        errors={errors}
        {...wasteTypeSelector}
        onChange={(e) => {
          wasteTypeSelector.onChange(e);
          resetField(`${fieldArrayName}.${index}.disposalMethod`, { defaultValue: "" });
        }}
        placeholder=" "
        title={watchFieldArray[index].wasteType !== "" ?
          t(`inputs.wasteGeneratedInOperations.wasteType.options.${watchFieldArray[index].wasteActivity}.${watchFieldArray[index].wasteType}`) : ""}
      >
        {renderWasteTypeOptions(watchFieldArray[index].wasteActivity)}
      </FormSelect>
    );
    gridItems.push(
      <FormSelect
        errors={errors}
        {...register(`${fieldArrayName}.${index}.disposalMethod`, {
          required: globalTranslation("entityRequired", { entityName: t(`inputs.${tabKey}.disposalMethod.name`) })
        })}
        placeholder=" "
        title={watchFieldArray[index].disposalMethod !== "" ?
          t(`inputs.wasteGeneratedInOperations.disposalMethod.options.${watchFieldArray[index].disposalMethod}`) : ""}
      >
        {renderDisposalMethodOptions(watchFieldArray[index].wasteActivity, watchFieldArray[index].wasteType)}
      </FormSelect>
    );
    gridItems.push(
      <NumericFormInput
        errors={errors}
        {...register(`${fieldArrayName}.${index}.weight`, {
          required: globalTranslation("entityRequired", { entityName: t(`inputs.${tabKey}.weight`) }),
          pattern: VALIDATION_PATTERNS.POSITIVE_NUMBER
        })}
        type="number"
      />
    );

    return gridItems;
  };

  return (
    <CategoryModal
      modalData={modalData}
      formData={{ handleSubmit, fields, append, remove }}
      attributesOrder={attributesOrder}
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={onSubmit}
      getEmptyRow={getEmptyRow}
      mapRow={mapRow}
    />
  );

}

export default WasteGeneratedInOperationsModalWrapper;